const { default: authServices } = require("../../../../services/authServices");
const { default: dataProvider } = require("../../../../services/dataProvider");
var axios = require("axios");
var qs = require("qs");

export default function getAssociatedTask(formType) {
    var data = qs.stringify({
        formType
    });
    var config = {
        method: "post",
        url: dataProvider.baseUrl + "tasks-getTaskByFormType",
        headers: {
            orgid: authServices.getOrgId(),
            token: authServices.getToken(),
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data: data,
    };

    return axios(config) ;
}
